import { storage } from 'storage/sessionStorage';

export const getSessionUtmInfos = () => ({
  utm_source: storage.getItem('utm_source'),
  utm_medium: storage.getItem('utm_medium'),
  utm_campaign: storage.getItem('utm_campaign'),
});
